import { render, staticRenderFns } from "./FichaPopulacao.vue?vue&type=template&id=57c222ca&"
import script from "./FichaPopulacao.vue?vue&type=script&lang=js&"
export * from "./FichaPopulacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports